
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Grid } from "@mui/material";
import InputTextBox from '../../../../widgets/InputTextBox';
import NepaliInputTextBox from '../../../../widgets/NepaliInputTextBox';
import { ClearBtn, UpdateBtn } from '../../../../widgets/AppBtn';
import ComponentHeading from '../../../../widgets/ComponentHeading';
import { IoMdAddCircle } from "react-icons/io";
import { fetchDataFromApi, putDataToTheServer } from '../../../../widgets/api';
import AppURL from '../../../../widgets/AppURL';
import { ToastSuccess } from '../../../../widgets/ToastMessage';

const EnthinicityMappingEditView = ({ onEditID, setOnEditID, fetchAcademicsListView, onUpdateURL }) => {
  const [orgStrDetails, setOnClassStrDetails] = useState({});
  const [customValues, setCustomValues] = useState({
    caste_name_nep: "",
  });

  useEffect(() => {
    try {
      if (onEditID) {
        fetchDataFromApi(AppURL.AcademicsURL + "academics-ethnicity-mapping-retrieve-update-view/" + onEditID).then((res) => {
          setOnClassStrDetails(res?.data);
          setCustomValues({
            caste_name_nep: res?.data?.caste_name_nep || "",
          });
        });
      }
    } catch (error) {
      console.log(error);
    }
  }, [onEditID])


  const handleNepaliInputChange = (fieldName, value) => {
    handleChange(fieldName)(value)
    setCustomValues((prevValues) => ({
      ...prevValues,
      [fieldName]: value,
    }));
  };
  const initialValues = {
    caste_name: orgStrDetails?.caste_name || "",
    caste_name_nep: "",
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit } =
    useFormik({
      initialValues,
      enableReinitialize: true,
      onSubmit: async (values, action) => {
        const formData = new FormData();
        formData.append("caste_name", values.caste_name);
        formData.append("caste_name_nep", customValues.caste_name_nep);
        try {
          await putDataToTheServer(AppURL.AcademicsURL + "academics-ethnicity-mapping-retrieve-update-view/" + onEditID, formData).then(async (res) => {
            ToastSuccess(res?.message);
            await fetchAcademicsListView(onUpdateURL);
          });
        } catch (error) {
          console.log(error);
        }
      },
    });

  return (
    <form onSubmit={handleSubmit} className="px-4 py-4 dark:bg-slate800 bg-white rounded-md ">
      <ComponentHeading label={"Edit Enthinicity Mapping"} icon={IoMdAddCircle} />
      <Grid container spacing={1.5}>
        <Grid item xl={6} md={6} lg={6} xs={12} sm={12}>
          <InputTextBox
            name="caste_name"
            type="text"
            label={"Enthinicity Name"}
            value={values.caste_name}
            handleChange={handleChange}
            handleBlur={handleBlur}
            touched={touched.caste_name}
            errors={errors.caste_name}
            required={true}
          />
        </Grid>
        <Grid item xl={6} md={6} lg={6} xs={12} sm={12}>
          <NepaliInputTextBox
            name="caste_name_nep"
            label={"Enthinicity Name (Nepali)"}
            value={customValues.caste_name_nep}
            onCustomValueChange={handleNepaliInputChange}
            handleBlur={handleBlur}
            touched={touched.caste_name_nep}
            errors={errors.caste_name_nep}
            required={true}
          />
        </Grid>
      </Grid>
      <div className="flex justify-end mt-3 gap-2">
        <ClearBtn onClick={async () => await setOnEditID(false)} /> <UpdateBtn type="submit" />
      </div>
    </form>
  )
}

export default EnthinicityMappingEditView